import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useManufacturersApi } from "../../http/manufacturers/api";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type ManufacturerHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const ManufacturerHistoryDialog: FC<ManufacturerHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const manufacturersApi = useManufacturersApi();

  return (
    <HistoryDialog
      title={i18n.t.manufacturers.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={manufacturersApi.getAdminManufacturerVersion}
      getHistory={manufacturersApi.getAdminManufacturerHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.name}
                value={dataVersion.current?.name}
                edited={dataVersion.next.name}
              />
            </tr>
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default ManufacturerHistoryDialog;
